import { useTranslation } from 'react-i18next';
import { Follower } from '../../../../common/channel/channel-member';
import { Link, HoverableAvatar } from '../../../ui';

type ChannelMembersListProps = {
  followerCount: number | undefined;
  channelFollowers: Follower[];
};
const ChannelMembersList = ({
  followerCount,
  channelFollowers,
}: ChannelMembersListProps) => {
  const { t } = useTranslation();

  const renderFollower = (follower: Follower) => (
    <div className="channel-details-v2__follower" key={follower.id}>
      <Link href={`/profiles/${follower.id}`} action="push">
        <HoverableAvatar
          advocate={{
            id: follower.id.toString(),
            full_name: follower.name,
            display_name: follower.name,
            avatar: { url: follower.avatarUrl, color: follower.avatarColor },
          }}
        />
      </Link>
    </div>
  );

  return (
    <div className="channel-details-v2__followers">
      <h2 className="channel-details-v2__subtitle">
        {t('channel_details.number_joined', {
          count: followerCount,
        })}
      </h2>

      <div className="channel-details-v2__followers-list">
        {channelFollowers.map(renderFollower)}
      </div>
    </div>
  );
};

export default ChannelMembersList;
